module.exports = __webpack_public_path__ + "82b96c6caf19647951ac19109a5e5e5e.png";